import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import Lottie from "lottie-react";
//React Related & Redux
import { useDispatch, useSelector } from "react-redux";
//import { CART_CLEAR_ITEMS } from "./../../redux/cart/cartConstants";
import { removeFromCart } from "../../redux/cart/cartActions";
import { ADD_TO_CART_REQUEST_RESET } from '../../redux/cart/types'
//MUI
import { AlertTitle } from '@material-ui/lab';
import MuiAlert from "@material-ui/lab/Alert/Alert";
import Snackbar from "@material-ui/core/Snackbar/Snackbar";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import Hidden from "@material-ui/core/Hidden";
import Divider from "@material-ui/core/Divider";
import Button from "@material-ui/core/Button";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import TextField from "@material-ui/core/TextField";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import CircularProgress from "@material-ui/core/CircularProgress";
import Backdrop from "@material-ui/core/Backdrop";
import { withStyles } from "@material-ui/core/styles";
//Icons
import DeleteForeverIcon from "@material-ui/icons/DeleteForever";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
//My Components
import FactorGenerator from "../../components/FactorGenerator/FactorGenerator";
import * as globalFuncs from "../../globalFuncs/Entities/Product/Index";
import WideLayout from "../../layouts/WideLayout";
import OutlinedDiv from "../../components/Global/OutlinedDiv/Index";
import LoginModal from "../../components/LoginModal/Index";
import animationData from "../../assets/animation/cart.json";
import "./cartStyle.css";

const StyledPaper = withStyles({
    root: {
        backgroundColor: "transparent",
        position: "relative",
        boxShadow: "none",
        paddingTop: "0",
    },
})(Paper);

const LimitedBackdrop = withStyles({
    root: {
        backgroundColor: "rgb(0, 0, 0,0.2)",
        height: "105%",
        position: "absolute",
        zIndex: 1,
        color: "#fff",
        borderRadius: "10px",
        marginTop: "-10px",
    },
})(Backdrop);

const LimitedBackdropCart = withStyles({
    root: {
        backgroundColor: "rgb(0, 0, 0,0.2)",
        height: "105%",
        position: "absolute",
        zIndex: 1,
        color: "#fff",
        borderRadius: "10px",
    },
})(Backdrop);

export function Alert(props) {
    return <MuiAlert elevation={6} severity="error" {...props} />;
}

const useStyles = makeStyles((theme) => ({
    break: {
        flexBasis: "100%",
        width: 0,
        height: 0,
    },
    noBoxShadow: {
        boxShadow: "none",
    },
    container: {
        [theme.breakpoints.up("lg")]: {
            width: 1234,
        },
    },
    pad: {
        [theme.breakpoints.down("sm")]: {
            padding: "0 20px",
        },
        [theme.breakpoints.down("xs")]: {
            padding: "0 0px",
        },
    },
    base: {
        flexGrow: 1,
        marginTop: "24px",
    },
    grayBox: {
        backgroundColor: "#f2f2f2",
    },
    textArea: {
        padding: "10px",
        borderRadius: "10px",
        backgroundColor: "#fff",
    },
    whiteBox: {
        backgroundColor: "#ffffff",
    },
    paperNoBg: {
        backgroundColor: "transparent",
    },
    paper: {
        padding: theme.spacing(2),
        textAlign: "left",
        color: theme.palette.text.secondary,
    },
    stepLabel: {
        fontWeight: "700",
    },
    btnAdd: {
        backgroundColor: "#fff",
        paddingTop: "10px",
        paddingBottom: "10px",
        fontWeight: "bold",
        color: "#3B3B3B",
        "&:hover": {
            backgroundColor: "#fff",
            paddingTop: "10px",
            paddingBottom: "10px",
        },
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
        width: "150px",
        backgroundColor: "#f5f5f5",
        borderRadius: "8px",
        border: "1px #3d3d3d solid",
        height: "40px",
        marginTop: "0px",
        paddingRight: "10px !important",
        [theme.breakpoints.down("sm")]: {
            fontSize: "14px",
            display: "relative",
            width: "fit-content",
            paddingRight: "1px !important",
            margin: "0 auto",
        },
    },
    fullWidthSelect: {
        marginTop: theme.spacing(2),
        width: "100%",
        backgroundColor: "#f5f5f5",
        borderRadius: "8px",
        border: "1px #3d3d3d solid",
        height: "40px",
        marginTop: "0px",
        paddingRight: "10px !important",
    },
    root: {
        display: "flex",
    },
    OutlinedDiv: {
        backgroundColor: "transparent",
        margin: "0px 30px",
    },
    back: {
        width: "140px",
        backgroundColor: "#ffa000",
        fontWeight: "700",
        color: "#fff",
        "&:hover": {
            backgroundColor: "#b28704",
        },
    },
    btnNext: {
        display: "block",
        minWidth: "140px",
        backgroundColor: "#28a504",
        fontWeight: "700",
        color: "#fff",
        "&:hover": {
            backgroundColor: "#417557",
        },
    },
    img: {
        width: "90px",
    },
    margin: {
        margin: "0px 10px 0px 10px",
    },
    withoutLabel: {
        marginTop: theme.spacing(3),
    },
    textField: {
        width: "100%",
    },
    textWhite: {
        backgroundColor: "#fff",
    },
    btnInline: {
        display: "inline",
    },
    btnSave: {
        display: "inline",
        width: "172px",
        backgroundColor: "#28a504",
        marginLeft: "21px",
        fontWeight: "700",
        "&:hover": {
            backgroundColor: "#417557",
        },
    },
    smCenter: {
        [theme.breakpoints.down("sm")]: {
            textAlign: "center",
            width: "fit-content",
        },
    },
    textSm: {
        [theme.breakpoints.down("xs")]: {
            textAlign: "center",
            fontSize: "12px",
        },
    },
    inputNumber: {
        border: "none",
        width: "50px",
        textAlign: "center",
        fontSize: "17px",
        background: "#fff",
        paddingTop: "10px",
        [theme.breakpoints.down("xs")]: {
            width: "25px",
        },
    },
}));

let cartArray = [];
let wholeArray = [];
let allPrice = 0;
let totalCounts = 0;
const bread = [
    { title: "صفحه اصلی", to: "/" },
    { title: "سبد خرید", to: "/cart" },
];

function msgError(key) {
    switch (key) {
        case "WayOfSendIsInvalid":
            return "پیک شهری تنها ویژه ساکنین مشهد می باشد. آدرس وارد شده شما مربوط به شهر مشهد نیست.";
        case "OneOfProductIsOutOfStock":
            return "برخی از محصولات سبد خرید شما در انبار موجود نمی باشد.";
        case "PackIdIsInvalid":
            return "وزن انتخاب شده شما در انبار موجود نیست";
        case "CodeAddressIsInvalid":
            return "آدرس انتخاب شده شما اشتباه می باشد";
        case "CodeAddressIsInvalid":
            return "آدرس یافت نشد";
        case "ProfileNotFound":
            return "اطلاعات کاربری شما یافت نشد";
        case "UserNotFound":
            return "حساب کاربری شما یافت نشد لطفا ثبت نام نمایید";
    }
}

function switcher(key) {
    switch (key) {
        case "1":
            return "250";
        case "2":
            return "500";
        case "4":
            return "1000";
        default:
            return "";
    }
}

function getSteps(loggedIn = false) {
    return [
        "تایید اقلام سفارش",
        "مشخصات تحویل گیرنده",
        "پیش فاکتور",
        "تسویه حساب",
    ];
}

const Cart = () => {
    //Public Consts
    const classes = useStyles();
    const [staticText, setStaticText] = useState({});
    const [loading, setLoading] = useState(false);
    const [cartLoading, setCartLoading] = useState(false);

    const [error, setError] = useState(false);
    const dispatch = useDispatch();
    //end tmp
    //page related consts
    const [addresses, setAddresses] = useState([]);
    const [totalPrice, setTotalPrice] = useState("");
    const [totalCount, setTotalCount] = useState(0);
    const [recipientOption, setRecipientOption] = useState("1");
    const [addressRadioOption, setAddressRadioOption] = useState("1");
    const [addressSelectAbility, setAddressSelectAbility] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [loadingAddress, setLoadingAddress] = useState(true);
    const [loadingBtn, setLoadingBtn] = useState(false);
    const [factorData, setFactorData] = useState({});
    const [finalFactorData, setFinalFactorData] = useState({});
    const [isAlert, setIsAlert] = React.useState({
        type: "error",
        open: false,
        msg: "",
    });
    const [defaultAddress, setDefaultAddress] = useState({
        id: 0,

        address: "",
    });

    const reduxCartState = useSelector(state => state.cart)
    const { reduxCartItems } = reduxCartState;
    useEffect(() => {
        if (typeof reduxCartState.reduxCartActionResult !== 'undefined' && reduxCartState.reduxCartActionResult !== null) {
            handleAlert(true, reduxCartState.reduxCartActionResult.message, reduxCartState.reduxCartActionResult.error ? 'error' : 'success')
            dispatch({ type: ADD_TO_CART_REQUEST_RESET })
        }
    }, [reduxCartState])

    const [wayOfSend, setWayOfSend] = useState("1");
    const [description, setDescription] = useState("");
    //MUI Related
    const steps = getSteps();
    const [activeStep, setActiveStep] = React.useState(0);
    const [breadcrumbsItems, setBreadcrumbsItems] = React.useState([]);
    const [width, setWidth] = useState(window.innerWidth);
    const handleResize = () => {
        setWidth(window.innerWidth);
    };

    useEffect(() => {
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);
    //funcs

    const handleAlert = (open, msg, Type = 'error') => {
        setIsAlert({
            open: open,
            type: Type,
            msg: msg,
        })
    };

    const handleOpenModal = () => {
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };

    const handlePayment = async () => {
        try {
            let config = {
                headers: {
                    Authorization: `Bearer ` + localStorage.getItem("token"),
                    "content-type": "application/json",
                },
            };
            const { data } = await axios.post(
                "/api/invoices/payInvoice",
                {
                    invoiceId: finalFactorData.invoiceNumber,
                },
                config
            );
            if (data.status === "ok") {
                document.location.href = `${data.data}`;
            }
        } catch (e) {
            console.log(e);
            handleAlert(true, "درخواست ناموفق بود");
        }
    };

    const handleFinal = () => {
        setLoadingBtn(true);
        handleFinalFactor();
    };

    const handleArray = () => {
        function prod() {
            cartArray = [];
            wholeArray = [];
            reduxCartItems.forEach((product) => {
                cartArray.push({
                    productId: product.id,
                    packId: switcher(product.weight),
                    packCount: product.count,
                });
            });
            return cartArray;
        }

        const def = {
            codeAddress: defaultAddress.id,
            fullAddress: defaultAddress.address,
            wayOfSend: wayOfSend,
            products: prod(),
            description: description,
        };
        wholeArray.push(def);
        localStorage.setItem("lastPreFactor", JSON.stringify(def));
        sendAxios(def);
    };

    const CheckAndRun = () => {
        if (defaultAddress.address.length <= 10) {
            handleAlert(true, "لطفا فیلد آدرس را به صورت کامل پر کنید");
        } else {
            setLoadingBtn(true);
            handleArray();
        }
    };

    const handleAddressOptionChange = (event) => {
        if (event.target.value === "2") {
            setDefaultAddress({
                id: "0",
                address: "",
            });
            setAddressRadioOption(event.target.value);
            setAddressSelectAbility(true);
        } else {
            if (addresses.length > 0) {
                setDefaultAddress({
                    id: addresses[0].id,
                    address: addresses[0].address,
                });
                setAddressRadioOption(event.target.value);
            }

            setAddressSelectAbility(false);
        }
    };

    const handleSetAddress = (event) => {
        const dataAddress = addresses.filter((e) => e.id === event.target.value);
        setDefaultAddress({
            id: dataAddress[0].id,
            address: dataAddress[0].address,
        });
    };

    const handleStep = () => {
        if (activeStep === 0) {
            localStorage.getItem("userInfo") ? handleNext() : handleOpenModal();
        }
        if (activeStep === 1) {
            CheckAndRun();
        }
    };

    // useEffect(() => {
    //     if (reduxCartItems) {
    //         setCartLoading(true);
    //         let prods = [];
    //         reduxCartItems.forEach((product) => {
    //             prods.push({
    //                 ProductId: parseInt(product.id),
    //                 Count: parseInt(product.count),
    //                 Pack: parseInt(switcher(product.weight)),
    //             });
    //         });
    //         const checkItems = async () => {
    //             const config = {
    //                 headers: {
    //                     Authorization: `Bearer ` + localStorage.getItem("token"),
    //                     "Content-Type": "application/json",
    //                 },
    //             };
    //             try {
    //                 const { data } = await axios.post(
    //                     "/api/invoices/cartCheck",
    //                     { cartProducts: prods },
    //                     config
    //                 );
    //                 if (data.status === "ok") {
    //                     if (data.data) {
    //                         data.data.forEach((item) => {
    //                             // dispatch(removeFromCart(parseInt(item)));
    //                         });
    //                         if (data.data.length > 0) {
    //                             handleAlert(
    //                                 true,
    //                                 "برخی از محصولات ناموجود از سبد خرید شما حذف گردید"
    //                             );
    //                         }
    //                     }
    //                     setCartLoading(false);
    //                 } else {
    //                     setCartLoading(false);
    //                 }
    //             } catch (e) {
    //                 setCartLoading(false);
    //             }
    //         };
    //         checkItems();
    //     }
    // }, []);

    useEffect(() => {
        if (allPrice !== 0) {
            allPrice = 0;
        }
        if (totalCounts !== 0) {
            totalCounts = 0;
        }
        if (reduxCartItems.length !== 0) {
            reduxCartItems.forEach((item) => {
                setTotalPrice((allPrice += item.totalPrice));
                setTotalCount((totalCounts += item.count));
            });
        }
        else {
            setTotalPrice(0)
            setTotalCount(0);
        }

    }, [reduxCartItems]);

    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const sendAxios = async (body) => {
        const config = {
            headers: {
                Authorization: `Bearer ` + localStorage.getItem("token"),
                "Content-Type": "application/json",
            },
        };
        try {
            const { data } = await axios.post(
                "/api/invoices/preInvoice",
                body,
                config
            );
            if (data.status === "ok") {
                setFactorData(data.data);
                setLoadingBtn(false);
                handleNext();
            } else {
                handleAlert(true, msgError(data.message));
                setLoadingBtn(false);
            }
        } catch (e) {
            console.log(e);
            setLoadingBtn(false);
        }
    };

    const getAddress = async (body) => {
        const config = {
            headers: {
                Authorization: `Bearer ` + localStorage.getItem("token"),
            },
        };
        try {
            const { data } = await axios.get("/api/invoices/getAddress", config);
            setLoadingAddress(false);
            if (data.status === "ok") {
                let addressesData = [];
                if (addressRadioOption === "1" && data.data.length !== 0) {
                    data.data.forEach((item) => {
                        addressesData.push({
                            id: item.id,
                            address: item.address,
                        });
                    });
                    setAddresses(addressesData);
                    setDefaultAddress({
                        id: addressesData[0].id,
                        address: addressesData[0].address,
                    });
                } else {
                    setAddressRadioOption("2");
                }
            }
        } catch (e) {
            console.log(e);
            setLoadingAddress(false);
        }
    };

    useEffect(() => {
        if (activeStep === 1) {
            setLoadingAddress(true);
            getAddress();
        }
    }, [activeStep]);

    const handleFinalFactor = async (body) => {
        const config = {
            headers: {
                Authorization: `Bearer ` + localStorage.getItem("token"),
                "Content-Type": "application/json",
            },
        };
        try {
            const { data } = await axios.post(
                "/api/invoices/addInvoice",
                localStorage.getItem("lastPreFactor"),
                config
            );
            if (data.status === "ok") {
                setFinalFactorData(data.data);
                handleNext();
                localStorage.removeItem("localStoragecartItems");
                //dispatch({ type: CART_CLEAR_ITEMS });
                setLoadingBtn(false);
            } else {
                setLoadingBtn(false);
                handleAlert(true, "عملیات با خطا مواجه شده است");
            }
        } catch (e) {
            console.log(e);
            setLoadingBtn(false);
            handleAlert(
                true,
                " عملیات با خطا مواجه شده است ، لطفا دوباره وارد شوید."
            );
        }
    };

    return (
        <>
            <WideLayout breadcrumbsItems={bread} title="سبد خرید | آجیل حسن پور"
                metas={{
                    keywords: "پسته ,فندق,آجیل , عید , پاستیل , زعفران , شیرینی , آلوچه ,لواشک ,بادام , مغز ,مغز گردو ,گردو , تخمه , پشمک , شکلات ,ماش ,لوبیا ",
                    description: 'فروش و پخش عمده و جزئی بهترین آجیل و خشکبار شامل انواع پسته، بادام، فندق، گردو، آجیل مخصوص کادو، زعفران، میوه خشک، شکلات، چای و ...',
                    subject: "nuts",
                    copyright: 'Ajilhassanpour',
                    robots: "noindex"
                }}>
                <Grid item xs={12}>
                    <Paper elevation={0}>
                        <div>
                            <Stepper activeStep={activeStep} alternativeLabel>
                                {steps.map((label, index) => (
                                    <Step key={label}>
                                        <StepLabel className={classes.stepLabel}>
                                            {label}
                                        </StepLabel>
                                    </Step>
                                ))}
                            </Stepper>
                        </div>
                    </Paper>
                </Grid>
                <Grid item xs={12}>
                    <Box
                        boxShadow={1}
                        className={
                            activeStep <= 1
                                ? classes.grayBox + " cart"
                                : `cart ${classes.noBoxShadow}`
                        }>
                        <Grid container spacing={1}>
                            {activeStep === 0 ? (
                                <Grid item xs={12}>
                                    <Box px={1}>
                                        {(reduxCartItems.length) > 0 ? (
                                            <>
                                                <Hidden only={["xs"]}>
                                                    <Box
                                                        bgcolor="#950000"
                                                        borderRadius={10}
                                                        color="#fff"
                                                        mt={1}
                                                        p={2}
                                                        textAlign="center">
                                                        <Grid container>
                                                            <Grid item xs={1}>
                                                                <Box
                                                                    display="flex"
                                                                    justifyContent="center"
                                                                    alignItems="center"
                                                                    height="100%">ردیف</Box>
                                                            </Grid>
                                                            <Grid item xs={2}>
                                                                <Box
                                                                    display="flex"
                                                                    justifyContent="center"
                                                                    alignItems="center"
                                                                    height="100%">تصویر محصول</Box>
                                                            </Grid>
                                                            <Grid item xs={2}>
                                                                <Box
                                                                    display="flex"
                                                                    justifyContent="center"
                                                                    alignItems="center"
                                                                    height="100%">نام محصول</Box>
                                                            </Grid>
                                                            <Grid item xs={2}>
                                                                <Box
                                                                    display="flex"
                                                                    justifyContent="center"
                                                                    alignItems="center"
                                                                    height="100%">قیمت واحد</Box>
                                                            </Grid>
                                                            <Grid item xs={1}>
                                                                <Box
                                                                    display="flex"
                                                                    justifyContent="center"
                                                                    alignItems="center"
                                                                    height="100%">وزن</Box>
                                                            </Grid>
                                                            <Grid item xs={1}>
                                                                <Box
                                                                    display="flex"
                                                                    justifyContent="center"
                                                                    alignItems="center"
                                                                    height="100%">تعداد</Box>
                                                            </Grid>
                                                            <Grid item xs={1}>
                                                                <Box
                                                                    display="flex"
                                                                    justifyContent="center"
                                                                    alignItems="center"
                                                                    height="100%"> قیمت کل</Box>
                                                            </Grid>
                                                            <Grid item xs={2}>
                                                                <Box
                                                                    display="flex"
                                                                    justifyContent="center"
                                                                    alignItems="center"
                                                                    height="100%">عملیات</Box>
                                                            </Grid>
                                                        </Grid>
                                                    </Box>
                                                </Hidden>
                                                {reduxCartItems.map((product, i) => (
                                                    <>
                                                        <Hidden only={["md", "lg", "xl"]}>
                                                            <Box
                                                                style={{ padding: "15px 15px 25px 15px" }}
                                                                bgcolor="#fff"
                                                                borderRadius={10}
                                                                boxShadow="-4px 4px 18px rgba(0, 0, 0, 0.18)"
                                                                mt={2}
                                                                textAlign="center">
                                                                <Grid container spacing={1}>
                                                                    <Grid item xs={12}>
                                                                        <Box
                                                                            fontSize='0.8rem'
                                                                            borderBottom="1px #ccc solid"
                                                                            pt={1}
                                                                            pb={1}
                                                                            textAlign="center">
                                                                            <Grid container spacing={1}>
                                                                                <Grid item xs={10}>
                                                                                    <Box
                                                                                        display="flex"
                                                                                        justifyContent="left"
                                                                                        alignItems="left"
                                                                                        ml={1}
                                                                                        fontSize='0.85rem'
                                                                                        height="100%">
                                                                                        <Link to={`/product/${product.id}`} style={{ color: '#000' }}>
                                                                                            <strong>{product.title}</strong>
                                                                                        </Link>
                                                                                    </Box>
                                                                                </Grid>
                                                                                <Grid item xs={2}>
                                                                                    <Box
                                                                                        display="flex"
                                                                                        justifyContent="center"
                                                                                        alignItems="center"
                                                                                        mr={1}
                                                                                        height="100%">
                                                                                        <DeleteForeverIcon
                                                                                            style={{ fill: "#950000", cursor: "pointer" }}
                                                                                            onClick={() => {
                                                                                                dispatch(removeFromCart(product.id))
                                                                                            }} />
                                                                                    </Box>
                                                                                </Grid>
                                                                            </Grid>
                                                                        </Box>
                                                                    </Grid>
                                                                    <Grid item xs={3} areaLabel='تصویر'>
                                                                        <Box
                                                                            display="flex"
                                                                            justifyContent="top"
                                                                            alignItems="top"
                                                                            height="100%">
                                                                            <Link to={`/product/${product.id}`}>
                                                                                <img
                                                                                    src={product.thumbnailImgURL}
                                                                                    style={{ width: '100%', marginTop: '10px' }}
                                                                                />
                                                                            </Link>
                                                                        </Box>
                                                                    </Grid>
                                                                    <Grid item xs={9} areaLabel='نام محصول'>
                                                                        <Box pt={0}>
                                                                            <Grid container spacing={1}>
                                                                                <Grid item xs={12} style={{ height: "45px" }}>
                                                                                    <Box
                                                                                        fontSize='0.8rem'
                                                                                        fontWeight='700'
                                                                                        borderRadius={10}
                                                                                        pt={1}
                                                                                        pb={1}
                                                                                        textAlign="center">
                                                                                        <Grid container>
                                                                                            <Grid item xs={3}>
                                                                                                <Box
                                                                                                    display="flex"
                                                                                                    justifyContent="center"
                                                                                                    alignItems="center"
                                                                                                    height="100%">وزن</Box>
                                                                                            </Grid>
                                                                                            <Grid item xs={3}>
                                                                                                <Box
                                                                                                    display="flex"
                                                                                                    justifyContent="center"
                                                                                                    alignItems="center"
                                                                                                    height="100%">تعداد</Box>
                                                                                            </Grid>
                                                                                            <Grid item xs={6}>
                                                                                                <Box
                                                                                                    display="flex"
                                                                                                    justifyContent="center"
                                                                                                    alignItems="center"
                                                                                                    height="100%"> قیمت کل</Box>
                                                                                            </Grid>
                                                                                        </Grid>
                                                                                    </Box>
                                                                                </Grid>
                                                                                <Grid item xs={3} style={{ height: "45px" }}>
                                                                                    <Box
                                                                                        display="flex"
                                                                                        justifyContent="center"
                                                                                        alignItems="center"
                                                                                        fontSize='0.8rem'
                                                                                        height="100%">
                                                                                        {(product.bulkSale) ? (
                                                                                            <>
                                                                                                {switcher(product.weight)}<br />گرمی
                                                                                        </>
                                                                                        ) : ('-')}
                                                                                    </Box>
                                                                                </Grid>
                                                                                <Grid item xs={3} style={{ height: "45px" }}>
                                                                                    <Box
                                                                                        display="flex"
                                                                                        justifyContent="center"
                                                                                        fontSize='0.8rem'
                                                                                        alignItems="center"
                                                                                        height="100%">{product.count}</Box>
                                                                                </Grid>
                                                                                <Grid item xs={6} style={{ height: "45px" }}>
                                                                                    <Box
                                                                                        display="flex"
                                                                                        justifyContent="center"
                                                                                        alignItems="center"
                                                                                        fontSize='0.8rem'
                                                                                        height="100%">
                                                                                        {globalFuncs.SepratePrice(
                                                                                            product.totalPrice
                                                                                        )}
                                                                                    </Box>
                                                                                </Grid>
                                                                            </Grid>

                                                                        </Box>
                                                                    </Grid>


                                                                </Grid>
                                                            </Box>
                                                        </Hidden>
                                                        <Hidden only={["xs"]}>
                                                            <Box
                                                                style={{ padding: "25px 15px 25px 15px" }}
                                                                bgcolor="#fff"
                                                                borderRadius={10}
                                                                boxShadow="-4px 4px 18px rgba(0, 0, 0, 0.18)"
                                                                mt={2}
                                                                textAlign="center">
                                                                <Grid container spacing={1}>
                                                                    <Grid item xs={1} areaLabel='ردیف'>
                                                                        <Box
                                                                            display="flex"
                                                                            justifyContent="center"
                                                                            alignItems="center"
                                                                            height="100%">{i + 1}</Box>
                                                                    </Grid>
                                                                    <Grid item xs={2} areaLabel='تصویر'>
                                                                        <Box
                                                                            display="flex"
                                                                            justifyContent="center"
                                                                            alignItems="center"
                                                                            height="100%">
                                                                            <Link to={`/product/${product.id}`}>
                                                                                <img
                                                                                    src={product.thumbnailImgURL}
                                                                                    className={classes.img}
                                                                                />
                                                                            </Link>
                                                                        </Box>
                                                                    </Grid>
                                                                    <Grid item xs={2} areaLabel='نام محصول'>
                                                                        <Box
                                                                            display="flex"
                                                                            justifyContent="center"
                                                                            alignItems="center"
                                                                            height="100%">
                                                                            <Link to={`/product/${product.id}`}>
                                                                                {product.title}
                                                                            </Link>
                                                                        </Box>
                                                                    </Grid>
                                                                    <Grid item xs={2} areaLabel='قیمت واحد'>
                                                                        <Box
                                                                            display="flex"
                                                                            justifyContent="center"
                                                                            alignItems="center"
                                                                            height="100%">
                                                                            {globalFuncs.SepratePrice(
                                                                                product.price
                                                                            )}
                                                                        </Box>
                                                                    </Grid>
                                                                    <Grid item xs={1} areaLabel='وزن'>
                                                                        <Box
                                                                            display="flex"
                                                                            justifyContent="center"
                                                                            alignItems="center"
                                                                            height="100%">
                                                                            {(product.bulkSale) ? (
                                                                                <>
                                                                                    {switcher(product.weight)}&nbsp;گرمی
                                                                            </>
                                                                            ) : ('-')}
                                                                        </Box>
                                                                    </Grid>
                                                                    <Grid item xs={1} areaLabel='تعداد'>
                                                                        <Box
                                                                            display="flex"
                                                                            justifyContent="center"
                                                                            alignItems="center"
                                                                            height="100%">{product.count}</Box>
                                                                    </Grid>
                                                                    <Grid item xs={1} areaLabel='قیمت کل'>
                                                                        <Box
                                                                            display="flex"
                                                                            justifyContent="center"
                                                                            alignItems="center"
                                                                            height="100%">
                                                                            {globalFuncs.SepratePrice(
                                                                                product.totalPrice
                                                                            )}
                                                                        </Box>
                                                                    </Grid>
                                                                    <Grid item xs={2} areaLabel='عملیات'>
                                                                        <Box
                                                                            display="flex"
                                                                            justifyContent="center"
                                                                            alignItems="center"
                                                                            height="100%">
                                                                            <DeleteForeverIcon
                                                                                style={{ fill: "#950000", cursor: "pointer" }}
                                                                                onClick={() => {
                                                                                    dispatch(removeFromCart(product.id))
                                                                                }} />
                                                                        </Box>
                                                                    </Grid>
                                                                </Grid>
                                                            </Box>
                                                        </Hidden>
                                                    </>
                                                ))}
                                                <Box
                                                    bgcolor="#950000"
                                                    borderRadius={10}
                                                    color="#fff"
                                                    mt={2}
                                                    mb={1}
                                                    p={2}
                                                    textAlign="center">
                                                    <Hidden only={["xs"]}>
                                                        <Grid container>
                                                            <Grid item xs={4}></Grid>
                                                            <Grid item xs={1}>
                                                                <Box
                                                                    display="flex"
                                                                    justifyContent="center"
                                                                    alignItems="center"
                                                                    height="100%">
                                                                    <span style={{ fontWeight: "700" }}>کل بسته ها:</span>&nbsp;
                                                            </Box>
                                                            </Grid>
                                                            <Grid item md={1} xs={2}>
                                                                <Box
                                                                    display="flex"
                                                                    justifyContent="left"
                                                                    alignItems="left"
                                                                    height="100%">
                                                                    {totalCount}
                                                                </Box>
                                                            </Grid>
                                                            <Grid item xs={1}>
                                                                <Box
                                                                    display="flex"
                                                                    justifyContent="center"
                                                                    alignItems="center"
                                                                    height="100%">
                                                                    <span style={{ fontWeight: "700" }}>قیمت کل:</span>&nbsp;
                                                            </Box>
                                                            </Grid>
                                                            <Grid item xs={1}>
                                                                <Box
                                                                    display="flex"
                                                                    justifyContent="left"
                                                                    alignItems="left"
                                                                    height="100%">
                                                                    {globalFuncs.SepratePrice(
                                                                        totalPrice
                                                                    )}
                                                                </Box>
                                                            </Grid>
                                                            <Grid item xs={4}></Grid>
                                                        </Grid>
                                                    </Hidden>
                                                    <Hidden only={["md", "lg", "xl"]}>
                                                        <Grid container>
                                                            <Grid item xs={6}>
                                                                <Box
                                                                    display="flex"
                                                                    justifyContent="center"
                                                                    alignItems="center"
                                                                    fontSize='0.8rem'
                                                                    height="100%">
                                                                    <span style={{ fontWeight: "700" }}>کل بسته ها:</span>&nbsp;
                                                            </Box>
                                                            </Grid>
                                                            <Grid item xs={6}>
                                                                <Box
                                                                    display="flex"
                                                                    justifyContent="center"
                                                                    alignItems="center"
                                                                    fontSize='0.8rem'
                                                                    height="100%">
                                                                    <span style={{ fontWeight: "700" }}>قیمت کل:</span>&nbsp;
                                                            </Box>
                                                            </Grid>
                                                            <Grid item xs={6}>
                                                                <Box
                                                                    display="flex"
                                                                    justifyContent="center"
                                                                    alignItems="center"
                                                                    fontSize='0.8rem'
                                                                    height="100%">
                                                                    {totalCount}
                                                                </Box>
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                <Box
                                                                    display="flex"
                                                                    justifyContent="center"
                                                                    alignItems="center"
                                                                    fontSize='0.8rem'
                                                                    height="100%">
                                                                    {globalFuncs.SepratePrice(
                                                                        totalPrice
                                                                    )}
                                                                </Box>
                                                            </Grid>
                                                            <Grid item md={4} xs={12}></Grid>
                                                        </Grid>

                                                    </Hidden>

                                                </Box>
                                            </>
                                        ) : (
                                            <>
                                                <Box
                                                    width="100%"
                                                    display="flex"
                                                    justifyContent="center"
                                                    textAlign="center"
                                                    alignItems="center">
                                                    <Lottie
                                                        loop={true}
                                                        autoplay={true}
                                                        animationData={animationData}
                                                        style={{
                                                            width: "400px",
                                                            height: "400px",
                                                            margin: "0 auto",
                                                        }}
                                                    />
                                                </Box>
                                                <Box
                                                    textAlign="center"
                                                    color="gray"
                                                    fontSize={30}
                                                    fontWeight="bold"
                                                    mt={2}
                                                    pb={2}
                                                    mb={4}>سبد خرید شما خالی می باشد.<br /><br />
                                                    <Link to="/products">
                                                        <Button
                                                            variant="contained"
                                                            className={classes.btnAdd}
                                                            color="inherit">+افزودن محصول جدید</Button>
                                                    </Link>
                                                </Box>
                                            </>
                                        )}
                                    </Box>
                                </Grid>
                            ) : activeStep === 1 ? (
                                <Grid item xs={12}>
                                    <Box className={classes.pad}>
                                        <StyledPaper>
                                            <OutlinedDiv
                                                className={classes.OutlinedDiv}
                                                label="محل تحویل مرسوله">
                                                <LimitedBackdrop open={loadingAddress}>
                                                    <CircularProgress color="inherit" />
                                                </LimitedBackdrop>
                                                <Grid container xs={12} md={12}>
                                                    <Grid item md={3} xs={12}>
                                                        <RadioGroup
                                                            aria-label="mainCat"
                                                            name="mainCat"
                                                            value={addressRadioOption}
                                                            onChange={handleAddressOptionChange}>
                                                            <FormControlLabel
                                                                value={"1"}
                                                                control={<Radio />}
                                                                label={"استفاده از آدرس های ذخیره شده"}
                                                            />
                                                            <FormControlLabel
                                                                value={"2"}
                                                                control={<Radio />}
                                                                label={"ثبت آدرس جدید"}
                                                            />
                                                        </RadioGroup>
                                                    </Grid>
                                                    <Grid item md={9} xs={12}>
                                                        <Box p={2}>
                                                            <Select
                                                                value={defaultAddress.id}
                                                                onChange={handleSetAddress}
                                                                disabled={addressSelectAbility}
                                                                className={classes.fullWidthSelect}
                                                                inputProps={{
                                                                    "aria-label": "Without label",
                                                                }}
                                                                style={{ width: "100%" }}
                                                                placeholder="انتخاب آدرس ...">
                                                                <MenuItem selected disabled value="">
                                                                    <em>انتخاب آدرس</em>
                                                                </MenuItem>
                                                                {addresses.map((address, i) => (
                                                                    <MenuItem key={i} value={address.id}>
                                                                        {address.address}
                                                                    </MenuItem>
                                                                ))}
                                                            </Select>
                                                            <TextField
                                                                fullWidth
                                                                multiline
                                                                disabled={
                                                                    addressRadioOption === "1"
                                                                        ? true
                                                                        : false
                                                                }
                                                                placeholder="لطفا آدرس خود را در این قسمت وارد نمایید..."
                                                                className={classes.textArea}
                                                                style={{
                                                                    width: "98%",
                                                                    marginTop: "20px",
                                                                }}
                                                                value={defaultAddress.address}
                                                                // onClick={handleClickAddress}
                                                                onChange={(e) =>
                                                                    setDefaultAddress({
                                                                        id: defaultAddress.id,
                                                                        address: e.target.value,
                                                                    })
                                                                }
                                                                rows={5} />
                                                        </Box>
                                                    </Grid>
                                                </Grid>
                                            </OutlinedDiv>
                                        </StyledPaper>
                                        <OutlinedDiv label="روش ارسال مرسوله">
                                            <RadioGroup
                                                row
                                                aria-label="wayOfSend"
                                                name="wayOfSend"
                                                value={wayOfSend}
                                                onChange={(e) => setWayOfSend(e.target.value)}
                                                defaultValue="top">
                                                <FormControlLabel
                                                    value="1"
                                                    control={<Radio color="primary" />}
                                                    label="پست سفارشی"
                                                />
                                                <FormControlLabel
                                                    value="2"
                                                    control={<Radio color="primary" />}
                                                    label="پست پیشتاز"
                                                />
                                                <FormControlLabel
                                                    value="3"
                                                    control={<Radio color="primary" />}
                                                    label="پیک شهری ( ویژه مشهد )"
                                                />
                                            </RadioGroup>
                                            <Alert severity="error" style={{ marginTop: '15px' }}>هزینه ارسال به محل محاسبه و در هنگام تحویل مرسوله دریافت می گردد.</Alert>
                                            <Alert severity="info" style={{ marginTop: '15px' }}>
                                                <AlertTitle>ارسال رایگان</AlertTitle>
                                                <ul>
                                                     <li>برای سفارشات بالای <strong>۷۰۰ هزار تومان</strong> ساکنین <strong>مشهد</strong>.</li>
                                                </ul>
                                            </Alert>
                                        </OutlinedDiv>
                                        <OutlinedDiv
                                            className={classes.OutlinedDiv}
                                            label="توضیحات">
                                            <Box>
                                                <TextField
                                                    fullWidth
                                                    multiline
                                                    rows={5}
                                                    style={{ width: "98%" }}
                                                    aria-label="description"
                                                    name="description"
                                                    className={classes.textArea}
                                                    value={description}
                                                    onChange={(e) =>
                                                        setDescription(e.target.value)
                                                    }
                                                    placeholder="توضیحات ...."
                                                />
                                            </Box>
                                        </OutlinedDiv>
                                    </Box>
                                </Grid>
                            ) : activeStep === 2 ? (
                                <>

                                    <FactorGenerator factor={factorData} />
                                    <Grid container spacing={1}>
                                        {factorData.totalPrice === "-" && (
                                            <Grid item xs={12}>
                                                <Box
                                                    justifyContent="center"
                                                    display="flex"
                                                    alignContent="center"
                                                    textAlign="center"
                                                    alignItems="center">
                                                    <Alert style={{ maxWidth: "400px" }} className={classes.noBoxShadow}>
                                                        برخی از محصولات مورد نظر در انبار موجود نمی
                                                        باشد.
                                                    </Alert>
                                                </Box>
                                            </Grid>
                                        )}
                                        <Grid item xs={6}>
                                            <Box style={{ textAlign: 'left' }} p={1}>
                                                <Link to="/">
                                                    <Button
                                                        variant="contained"
                                                        style={{
                                                            backgroundColor: "#A22020",
                                                            color: "#fff",
                                                        }}>
                                                        انصراف
                                                    </Button>
                                                </Link>
                                            </Box>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <Box style={{ textAlign: 'right' }} p={1}>
                                                <Button
                                                    variant="contained"
                                                    disabled={
                                                        factorData.totalPrice === "-" ? true : false
                                                    }
                                                    className={classes.btnNext}
                                                    onClick={handleFinal}>
                                                    {!loadingBtn ? (
                                                        " تایید نهایی"
                                                    ) : (
                                                        <CircularProgress color="inherit" size={22} />
                                                    )}
                                                </Button>
                                            </Box>
                                        </Grid>
                                    </Grid>

                                </>
                            ) : (
                                <>

                                    <FactorGenerator confirm={true} factor={finalFactorData} />
                                    <Grid container spacing={1}>
                                        {factorData.totalPrice === "-" && (
                                            <Box
                                                justifyContent="center"
                                                display="flex"
                                                alignContent="center"
                                                textAlign="center"
                                                alignItems="center">
                                                <Alert
                                                    style={{ maxWidth: "400px" }}
                                                    className={classes.noBoxShadow}>
                                                    برخی از محصولات مورد نظر در انبار موجود نمی
                                                    باشد.
                                            </Alert>
                                            </Box>
                                        )}
                                        <Grid item xs={6}>
                                            <Box style={{ textAlign: 'left' }} p={1}>
                                                <Link to="/">
                                                    <Button
                                                        variant="contained"
                                                        style={{
                                                            backgroundColor: "#A22020",
                                                            color: "#fff",
                                                        }}>انصراف</Button>
                                                </Link>
                                            </Box>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <Box style={{ textAlign: 'right' }} p={1}>
                                                <Button
                                                    variant="contained"
                                                    onClick={handlePayment}
                                                    disabled={
                                                        factorData.totalPrice === "-" ? true : false
                                                    }
                                                    className={classes.btnNext}>پرداخت</Button>
                                            </Box>
                                        </Grid>
                                    </Grid>

                                </>
                            )}
                        </Grid>
                    </Box>
                </Grid>
                <Grid item xs={12}>
                    {reduxCartItems.length > 0 && (
                        <Box mb={4} mt={2}>
                            {activeStep < 2 && (
                                <Box mr={2}>
                                    <Grid container justify="center" spacing={4}>
                                        <Grid item xs={6}>
                                            {activeStep > 0 && (
                                                <Box textAlign="left">
                                                    <Button
                                                        variant="contained"
                                                        className={classes.back}
                                                        disabled={
                                                            activeStep === 0 ? true : false
                                                        }
                                                        onClick={
                                                            activeStep === 0 ? null : handleBack
                                                        }><ArrowForwardIcon />&nbsp;مرحله قبل</Button>
                                                </Box>
                                            )}
                                        </Grid>
                                        <Grid item xs={6}>
                                            <Box>
                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    onClick={handleStep}
                                                    disabled={loadingBtn}
                                                    className={classes.btnNext}
                                                    style={{ marginRight: "auto" }}>
                                                    {loadingBtn ? (
                                                        <CircularProgress
                                                            size={18}
                                                            color="inherit"
                                                        />
                                                    ) : (
                                                        <>تایید و ادامه<ArrowBackIcon style={{ marginBottom: "-8px", float: "left" }} /></>
                                                    )}
                                                </Button>
                                            </Box>
                                        </Grid>
                                    </Grid>
                                </Box>
                            )}
                            {activeStep === 2 && (
                                <>
                                    <br />
                                    <Divider />
                                    <Box
                                        textAlign="left"
                                        mb={2}
                                        mt={2}
                                        className={classes.pad}>
                                        <Button
                                            variant="contained"
                                            className={classes.back}
                                            disabled={activeStep === 0 ? true : false}
                                            onClick={
                                                activeStep === 0 ? null : handleBack
                                            }><ArrowForwardIcon />&nbsp;مرحله قبل</Button>
                                    </Box>
                                </>
                            )}
                        </Box>
                    )}
                </Grid>
            </WideLayout>
            <LoginModal open={isModalOpen} onClose={handleCloseModal} redirect={false} />
            <Snackbar open={isAlert.open} autoHideDuration={3300} onClose={() => handleAlert(false, isAlert.msg)}><Alert>&nbsp;{isAlert.msg}</Alert></Snackbar>
        </>
    );
};

export default Cart;
